import React, { useState } from 'react';
import TreeCard from './components/TreeCard';
import TreeDetail from './components/TreeDetail';
import ImageTest from './components/ImageTest';
import { Tree } from './types/Tree';
import { californianTrees } from './data/trees';
import './App.css';

function App() {
  const [selectedTree, setSelectedTree] = useState<Tree | null>(null);
  const [showImageTest, setShowImageTest] = useState(false);

  const handleTreeSelect = (tree: Tree) => {
    setSelectedTree(tree);
  };

  const handleBackToTrees = () => {
    setSelectedTree(null);
  };

  if (showImageTest) {
    return (
      <div>
        <button onClick={() => setShowImageTest(false)}>Back to App</button>
        <ImageTest />
      </div>
    );
  }

  if (selectedTree) {
    return <TreeDetail tree={selectedTree} onBack={handleBackToTrees} />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <h1>🌳 Tree Explorer for Curious Kids! 🌳</h1>
        <p>Discover the amazing trees around you and ask all your questions!</p>
        <button 
          onClick={() => setShowImageTest(true)}
          style={{ marginTop: '10px', padding: '8px 16px', backgroundColor: 'white', color: '#2e7d32', border: 'none', borderRadius: '4px' }}
        >
          Test Images
        </button>
      </header>
      
      <main className="tree-gallery">
        <h2>Trees in California Parks</h2>
        <div className="trees-grid">
          {californianTrees.map(tree => (
            <TreeCard
              key={tree.id}
              tree={tree}
              onTreeSelect={handleTreeSelect}
            />
          ))}
        </div>
      </main>
    </div>
  );
}

export default App;
